import { motion } from 'framer-motion';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './Common.scss';

export default function Reserve() {
  const navigate = useNavigate();

  return (
    <Container fluid className="d-flex align-items-center min-vh-100">
      <Row className="justify-content-center w-100">
        <Col lg={8} md={10} sm={12} xs={12}>
          <Card className="shadow-sm h-100 slideinBottom">
            <Card.Body className="text-center py-4 d-flex flex-column justify-content-center">
              <h1 className="display-4 mb-4 text-success">ご予約</h1>
              <h2 className="h3 text-muted mb-4">
                ヒーリングサロンGundariの施術をご希望の方は、以下のボタンからご予約ください。興味を持ってくださっている段階で本当のあなたは今の現実を変えたいを強く願っているはずです！
              </h2>
              <motion.button
                className="btn btn-success btn-lg mt-4"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate('/reserve')}
              >
                ご予約はこちら
              </motion.button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
